import React from "react";
import { SvgWrapper } from "../styles";

export const AboutImg = ({ className }: { className?: string }) => {
  return (
    <SvgWrapper
      width="1.5vw"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 489.8 489.8"
      className={className}
    >
      <path
        fill="#7c7c7c"
        d="M66.4,404.2c5,0,9.1-4.1,9.1-9.1v-50.4c0-8,3.5-15.5,9.6-20.5c44.9-36.9,93.5-61.4,102.8-66
			c4.3-2.1,6.9-6.3,6.9-11.1v-70.9c0-3-1.5-5.9-4-7.5c-6.7-4.5-10.8-12-10.8-20V75.3c0-31.5,25.6-57.1,57.1-57.1h15.8
			c31.5,0,57.1,25.6,57.1,57.1v73.5c0,8.1-4,15.5-10.8,20c-2.5,1.7-4,4.5-4,7.5v70.9c0,4.8,2.7,9,6.9,11.1c9.3,4.5,58,29.1,102.8,66
			c6.1,5,9.6,12.5,9.6,20.5v50.4c0,5,4.1,9.1,9.1,9.1s9.1-4.1,9.1-9.1v-50.4c0-13.4-5.9-26-16.3-34.5
			c-42.5-34.9-88.3-59.2-103.1-66.6v-62.8c9.3-8,14.8-19.6,14.8-32.1V75.3c0-41.5-33.8-75.3-75.3-75.3H237
			c-41.5,0-75.3,33.8-75.3,75.3v73.5c0,12.4,5.5,24.1,14.8,32.1v62.8c-14.8,7.4-60.6,31.7-103.1,66.6c-10.3,8.5-16.3,21.1-16.3,34.5
			v50.4C57.4,400.1,61.4,404.2,66.4,404.2z"
      />
    </SvgWrapper>
  );
};
